import { createFeatureSelector, createSelector } from '@ngrx/store';
import { absenceReasonAdapter } from './absence-reasons.reducer';

export const selectAbsenceReasons = createFeatureSelector('absenceReasons');

export const selectAllAbsenceReasons = createSelector(
  selectAbsenceReasons,
  absenceReasonAdapter.getSelectors().selectAll,
);

export const selectAbsenceReason = (absenceReasonId: number) =>
  createSelector(selectAllAbsenceReasons, (absenceReasons) => {
    return absenceReasons.find((absenceReason) => absenceReason.id === absenceReasonId);
  });
